/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import React from "react";
import MaintenanceService from "../../service/MaintenanceService";
import autoTable from "jspdf-autotable";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import Package from "../../models/Package";

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    packageCd: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageEffdt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageDiscdt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageCompanyId: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageStatus: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packagePrice: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageNumStyles: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageOnline: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageFanwear: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    packageUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function PackageView() {
    const [listValues, setListValues] = useState<Package[]>([]);
    const [listFilteredData, setListFilteredData] = useState<Package[]>([]);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const toast = useRef<any>(null);
    const dt = useRef<any>(null);

    useEffect(() => {
        initFilters();
    }, []);

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    useEffect(() => {
        MaintenanceService.getPackages().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, []);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: Package) => [
            item.packageCd ?? '',
            item.packageDesc ?? '',
            item.packageNumStyles ?? 0,
            item.packagePrice ?? 0,
            item.packageEffdt ?? '',
            item.packageDiscdt ?? '',
            item.packageCompanyId ?? 0,
            item.packageStatus ?? '',
            item.packageOnline ?? '',
            item.packageFanwear ?? '',
            item.packageUpdUser ?? '',
            item.packageUpdTs ?? ''
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Package Code', 'Description', '# of Styles', 'Price', 'Effective Date', 'Disc Date', 'Company', 'Status', 'Design Studio', 'Fanwear', 'Last Update User', 'Last Update Date']], body: bodyData })
                doc.save('packages.pdf');
            });
        });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const packageCdTemplate = (rowData: Package) => {
        return rowData.packageCd;
    };

    const packageDescTemplate = (rowData: Package) => {
        return rowData.packageDesc;
    };

    const packageEffdtTemplate = (rowData: Package) => {
        return rowData.packageEffdt;
    };

    const packageDiscdtTemplate = (rowData: Package) => {
        return rowData.packageDiscdt;
    };

    const packageStatusTemplate = (rowData: Package) => {
        return rowData.packageStatus;
    };

    const packageCompanyId = (rowData: Package) => {
        return rowData.packageCompanyId;
    };

    const packagePriceTemplate = (rowData: Package) => {
        return rowData.packagePrice;
    };

    const packageNumStylesTemplate = (rowData: Package) => {
        return rowData.packageNumStyles;
    };

    const packageOnlineTemplate = (rowData: Package) => {
        return rowData.packageOnline;
    };

    const packageFanwearTemplate = (rowData: Package) => {
        return rowData.packageFanwear;
    };

    const packageUpduserTemplate = (rowData: Package) => {
        return rowData.packageUpdUser;
    };

    const packageUpdtsTemplate = (rowData: Package) => {
        return rowData.packageUpdTs;
    };


    return (
        <>
            <Toast ref={toast} />

            <DataTable ref={dt} className="-ml-2" value={listValues}
                dataKey="packageCd" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No package records found." header={header}>
                <Column field="packageCd" header="Package Code" sortable body={packageCdTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageDesc" header="Description" sortable body={packageDescTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageNumStyles" header="# of Styles" sortable body={packageNumStylesTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packagePrice" header="Price" sortable body={packagePriceTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageEffdt" header="Effective Date" sortable body={packageEffdtTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageDiscdt" header="Disc Date" sortable body={packageDiscdtTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageCompanyId" header="Company" sortable body={packageCompanyId} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageStatus" header="Status" sortable body={packageStatusTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageOnline" header="Design Studio" sortable body={packageOnlineTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageFanwear" header="Fanwear" sortable body={packageFanwearTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageUpdUser" header="Last Update User" sortable body={packageUpduserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="packageUpdTs" header="Last Update Date" sortable body={packageUpdtsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
            </DataTable>
        </>
    )
}